<button
  [attr.type]="type()"
  class="parent-btn"
  [class.parent-btn--block]="fullWidth()"
  [class.parent-btn--spread]="spread()"
  [class.parent-btn--primary]="variant() === 'primary'"
  [class.parent-btn--success]="variant() === 'success'"
  [class.parent-btn--ghost]="variant() === 'ghost'"
  [class.parent-btn--icon]="variant() === 'icon'"
  [class.parent-btn--text-ghost]="variant() === 'text-ghost'"
  [class.parent-btn--text-danger]="variant() === 'text-danger'"
  [disabled]="disabled() || loading()"
  (click)="onClick($event)"
>
  @if (loading()) {
    <span
      class="parent-btn__spinner"
      [class.parent-btn__spinner--inverse]="variant() === 'primary'"
      [class.parent-btn__spinner--success]="variant() === 'success'"
      aria-hidden="true"
    ></span>
  }
  <ng-content />
</button>
